import _DataPod from "../_DataPod";
import { IPortfolioAnalysisPodModel } from "../../../../../../model/compute/IPods";

export default class _PortfolioAnalysis extends _DataPod implements IPortfolioAnalysisPodModel {}
